module.exports = __webpack_public_path__ + "img/loading.8cbd1a75.gif";